import {
  getCenturyStart,
  getDecadeEnd,
  getDecadeStart,
} from "@wojtekmaj/date-utils";

import Tile from "../Tile";

import { formatYear as defaultFormatYear } from "../shared/dateFormatter";
import { getDecadeLabel } from "../shared/dates";

const className = "react-calendar__century-view__decades__decade";

export default function Decade({
  classes = [],
  currentCentury,
  formatYear = defaultFormatYear,
  ...otherProps
}) {
  const { date, locale } = otherProps;

  const classesProps = [];

  if (classes) {
    classesProps.push(...classes);
  }

  if (className) {
    classesProps.push(className);
  }

  if (getCenturyStart(date).getFullYear() !== currentCentury) {
    classesProps.push(`${className}--neighboringCentury`);
  }

  return (
    <Tile
      {...otherProps}
      classes={classesProps}
      maxDateTransform={getDecadeEnd}
      minDateTransform={getDecadeStart}
      view="century"
    >
      {getDecadeLabel(locale, formatYear, date)}
    </Tile>
  );
}
